import { IconName } from '@aloft/toolkit-sui';

import { TkOrderListField, Tkv2SortState } from '../types.ts';

export const getTkv2SortIcon = (field: TkOrderListField, sortState: Tkv2SortState): IconName => {
  if (field === sortState.field) return sortState.dir === 'asc' ? 'arrow-up' : 'arrow-down';
  return 'arrow-up-down';
};
